<template>
  <div
    v-show="visible"
    class="sort-container top-100 ltr:right-0 rtl:left-0"
    :class="{ rtl: isRTLView }"
    @click.stop
  >
    <div class="font-semibold text-xs/[20px] text-gray-400 px-2 pt-2 pb-1">
      {{ $t('ROLES.SORT_BY.TITLE') }}
    </div>

    <div
      class="sort-item"
      :class="{ active: value === 'asc' }"
      @click="$emit('select', 'asc')"
    >
      <span class="material-symbols-outlined text-base/[16px]">swap_vert</span>
      <span>{{ ascText || $t('ROLES.SORT_BY.OLDEST_FIRST') }}</span>
    </div>

    <div
      class="sort-item"
      :class="{ active: value === 'desc' }"
      @click="$emit('select', 'desc')"
    >
      <span class="material-symbols-outlined text-base/[16px] -scale-x-100">
        swap_vert
      </span>
      <span>{{ descText || $t('ROLES.SORT_BY.NEWEST_FIRST') }}</span>
    </div>
  </div>
</template>
<script>
import rtlMixin from 'shared/mixins/rtlMixin';
export default {
  mixins: [rtlMixin],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    ascText: {
      type: String,
      default: () => null,
    },
    descText: {
      type: String,
      default: () => null,
    },
    value: {
      type: String,
      default: () => '',
    },
    sortKey: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.sort-container {
  @apply absolute bg-white rounded-[8px] border border-gray-200 normal-case w-[208px] overflow-hidden;

  .sort-item {
    @apply font-normal text-sm/[20px] text-gray-600 px-2 py-1 flex flex-row items-center gap-[5px] cursor-pointer relative;

    &:last-child {
      @apply pt-1 pb-2;
    }

    &.active,
    &:hover {
      @apply bg-[#F0FDF4] text-[#164B35];
    }

    &.active {
      &:after {
        content: '';
        background-image: url(/images/checked.svg);
        width: 9px;
        height: 6px;
        background-origin: content-box;
        background-position-x: center;
        background-repeat: no-repeat;
        background-size: 9px 6px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 12px;
        padding: 0;
      }
    }
  }

  &.rtl {
    .sort-item {
      &.active,
      &:hover {
        &:after {
          right: unset;
          left: 12px;
        }
      }
    }
  }
}
</style>
